var map = {
	"./KelaFpa_cmyk.png": 860,
	"./Kela_cmyk.png": 861,
	"./OulunDiabetesyhdistys_logo.jpg": 862,
	"./Ppshp_kokonimi-L600.jpg": 863,
	"./TerveyskylÑ_logo.png": 864,
	"./Terveyskylä_logo.png": 865,
	"./companyLogo.png": 275,
	"./diabetesliitto-logo-fi.png": 866,
	"./kela-696x408.png": 867,
	"./maaseudunterveysjalomahuoltoLogo.png": 868,
	"./ppshp-ilmantekstia.png": 869,
	"./ppshp-logo.png": 870,
	"./ppshp.png": 272,
	"./vero_green_transparentv2.png": 871,
	"./vero_greenv2.png": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 859;